<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="epigraph" role="doc-epigraph">
<p class="sp"> </p>
<p class="EPV"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">My Life had stood - a Loaded Gun -</span></p>
<p class="EPV">In Corners - till a Day</p>
<p class="EPV">The Owner passed - identified -</p>
<p class="EPV">And carried Me away -</p>
<p class="EPC"><span class="small">—EMILY DICKINSON</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?4ae6946e